import styles from './MicroFrontendLoader.module.scss';

export function MicroFrontendLoader({
  theme = 'dark',
}: {
  theme?: 'light' | 'dark';
}) {
  return (
    <div className={styles.loaderWrapper}>
      <div
        className={`${styles.loader} ${
          theme === 'light' ? styles.loaderLight : styles.loaderDark
        }`}
      >
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}
